import { ReactNode } from "react";

import { COHORTS, useCohort } from "@/components/user-context";

import {
    ExistingUser as DefaultExistingUser,
    ManagedUser as DefaultManagedUser,
    NewUser as DefaultNewUser,
    WeekOneUser as DefaultWeekOneUser,
    UpgradeEligibleUser as DefaultUpgradeEligibleUser
} from "./components";

export const SiteActivationSwitcher = ({
    ExistingUser = <DefaultExistingUser />,
    ManagedUser = <DefaultManagedUser />,
    NewUser = <DefaultNewUser />,
    WeekOneUser = <DefaultWeekOneUser />,
    UpgradeEligibleUser = <DefaultUpgradeEligibleUser />,
    CurrentProductJoinableUser,
    CurrentProductUser,
    UpliftEligibleUser,
    CrossflowEligibleUser,
    useContactExpandCohortLogic
}: {
    ExistingUser?: ReactNode;
    ManagedUser?: ReactNode;
    NewUser?: ReactNode;
    WeekOneUser?: ReactNode;
    UpgradeEligibleUser?: ReactNode;
    CurrentProductJoinableUser?: ReactNode;
    CurrentProductUser?: ReactNode;
    UpliftEligibleUser?: ReactNode;
    CrossflowEligibleUser?: ReactNode;
    useContactExpandCohortLogic?: boolean;
    // eslint-disable-next-line complexity
}) => {
    const cohort = useCohort(useContactExpandCohortLogic);

    if (cohort === COHORTS.MANAGED_USER && ManagedUser) {
        return ManagedUser;
    }

    if (cohort === COHORTS.WEEK_ONE_USER && WeekOneUser) {
        return WeekOneUser;
    }

    if (
        cohort === COHORTS.CURRENT_PRODUCT_JOINABLE_USER &&
        CurrentProductJoinableUser
    ) {
        return CurrentProductJoinableUser;
    }

    if (cohort === COHORTS.CURRENT_PRODUCT_USER && CurrentProductUser) {
        return CurrentProductUser;
    }

    if (cohort === COHORTS.NEW_USER && NewUser) {
        return NewUser;
    }

    if (cohort === COHORTS.UPGRADE_ELIGIBLE_USER && UpgradeEligibleUser) {
        return UpgradeEligibleUser;
    }

    if (cohort === COHORTS.UPLIFT_ELIGIBLE_USER && UpliftEligibleUser) {
        return UpliftEligibleUser;
    }

    if (cohort === COHORTS.CROSSFLOW_ELIGIBLE_USER && CrossflowEligibleUser) {
        return CrossflowEligibleUser;
    }

    return ExistingUser;
};
